import {
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import { AppToastContainer } from "./components/AppToast.tsx";
import { routes } from "./routes.tsx";


function App() {
  const router = createBrowserRouter(routes);

  return (
    <>
      <div>
        <RouterProvider router={router}></RouterProvider>
      </div>
      <AppToastContainer />
    </>
  );
}

export default App;
